export const CHANGE_MODE="CHANGE_MODE";
export const SELECT_ITEM="SELECT_ITEM";

export const CHANGE_TOOL="CHANGE_TOOL";